import {take, call, put, select} from 'redux-saga/effects'

import {
  SENDING_HUBS_REQUEST,
  FETCH_HUBS_REQUEST,
  FETCH_HUBS_SUCCESS,
  FETCH_HUBS_FAILURE,
  SENDING_HUB_CREATE,
  CREATE_HUB_REQUEST,
  CREATE_HUB_FAILURE,
  SENDING_HUB_UPDATE,
  UPDATE_HUB_REQUEST,
  UPDATE_HUB_FAILURE,
  SENDING_HUB_DELETE,
  DELETE_HUB_REQUEST,
  DELETE_HUB_FAILURE,
  SENDING_HUB_UPLOAD,
  UPLOAD_HUB_REQUEST,
  UPLOAD_HUB_FAILURE,
  SENDING_HUB_UPGRADE,
  UPGRADE_HUB_REQUEST,
  UPGRADE_HUB_FAILURE
} from '../actions/constants'

import hub from '../api/hub'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;

function* fetchHubs({token, systemID}) {
  yield put({type: SENDING_HUBS_REQUEST, sending: true})
  try {
    return yield call(hub.fetchHubs, token, systemID)
  } catch (error) {
    yield put({type: FETCH_HUBS_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_HUBS_REQUEST, sending: false})
  }
}

export function* watchFetchHubs() {
  while (true) {
    yield take([FETCH_HUBS_REQUEST])
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(fetchHubs, {token, systemID})
    const arr = yield call(putNotify, {response})
    const hubs = Array.isArray(arr)
      ? arr
      : []
    yield put({type: FETCH_HUBS_SUCCESS, hubs: hubs});
  }
}

function* createHub({token, systemID, newHubState}) {
  yield put({type: SENDING_HUB_CREATE, sending: true})
  try {
    return yield call(hub.postHub, token, systemID, newHubState)
  } catch (error) {
    yield put({type: CREATE_HUB_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_HUB_CREATE, sending: false})
  }
}

export function* watchCreateHubRequest() {
  while (true) {
    const {newHubState} = yield take(CREATE_HUB_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(createHub, {token, systemID, newHubState})
    const notify = `Thêm mới địa bàn [${newHubState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_HUBS_REQUEST});
  }
}

function* updateHub({token, systemID, updateHubState}) {
  yield put({type: SENDING_HUB_UPDATE, sending: true})
  try {
    return yield call(hub.updateHub, token, systemID, updateHubState)
  } catch (error) {
    yield put({type: UPDATE_HUB_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_HUB_UPDATE, sending: false})
  }
}

export function* watchUpdateHubRequest() {
  while (true) {
    const {updateHubState} = yield take(UPDATE_HUB_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(updateHub, {token, systemID, updateHubState})
    const notify = `Cập nhật hub [${updateHubState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_HUBS_REQUEST});
  }
}

function* deleteHub({token, systemID, deleteHubState}) {
  yield put({type: SENDING_HUB_DELETE, sending: true})
  try {
    return yield call(hub.deleteHub, token, systemID, deleteHubState)
  } catch (error) {
    yield put({type: DELETE_HUB_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_HUB_DELETE, sending: false})
  }
}

export function* watchDeleteHubRequest() {
  while (true) {
    const {deleteHubState} = yield take(DELETE_HUB_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(deleteHub, {token, systemID, deleteHubState})
    const notify = `Xoá hub [${deleteHubState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_HUBS_REQUEST});
  }
}

function* uploadHub({token, systemID, newFirmwareState}) {
  yield put({type: SENDING_HUB_UPLOAD, sending: true})
  try {
    return yield call(hub.uploadHub, token, systemID, newFirmwareState)
  } catch (error) {
    yield put({type: UPLOAD_HUB_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_HUB_UPLOAD, sending: false})
  }
}

export function* watchUploadHubRequest() {
  while (true) {
    const {newFirmwareState} = yield take(UPLOAD_HUB_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(uploadHub, {token, systemID, newFirmwareState})
    const notify = `Upload firmware thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_HUBS_REQUEST});
  }
}

function* upgradeHub({token, systemID, newUpgradeListState}) {
  yield put({type: SENDING_HUB_UPGRADE, sending: true})
  try {
    return yield call(hub.upgradeHub, token, systemID, newUpgradeListState)
  } catch (error) {
    yield put({type: UPGRADE_HUB_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_HUB_UPGRADE, sending: false})
  }
}

export function* watchUpgradeHubRequest() {
  while (true) {
    const {newUpgradeListState} = yield take(UPGRADE_HUB_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(upgradeHub, {token, systemID, newUpgradeListState})
    const notify = newUpgradeListState.FirmwareDownloadEnable
      ? "Kích hoạt nâng cấp firmware thành công!"
      : "Ngừng kích hoạt nâng cấp firmware thành công!"
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_HUBS_REQUEST});
  }
}



// WEBPACK FOOTER //
// ./src/sagas/hub.js